import Utilities from '@util/Utilities';
import React from 'react';
import _uniqueId from 'lodash/uniqueId';
import { useFieldContext } from '@app/site/_form';


type CheckBoxFieldProps = {
	label?: string,
	hasError?: boolean,
	isLoading?: boolean,
	disabled?: boolean,
	extraClassName?: string,
	extraLabelClassName?: string,
	maxLength?: number,
	value: any
}

export const CheckboxField: React.FunctionComponent<CheckBoxFieldProps> = (props) => {
	const field = useFieldContext<string | string[]>();
	const uniqueId = _uniqueId('input-');

	const isArray = Array.isArray(field.state.value);
	const isChecked = isArray 
		? field.state.value.includes(props.value)
		: field.state.value === props.value;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (isArray) {
			const currentArray = field.state.value as string[];
			if (e.target.checked) {
				// Add value to array if not already present
				if (!currentArray.includes(props.value)) {
					field.handleChange([...currentArray, props.value]);
				}
			} else {
				// Remove value from array
				field.handleChange(currentArray.filter(v => v !== props.value));
			}
		} else {
			// Single value mode
			field.handleChange(e.target.value);
		}
	};

	return <div className="flex items-center">
		<input
			id={uniqueId}
			type="checkbox"
			disabled={props.disabled}
			className={Utilities.classNames("input-checkbox",
				!!props.extraClassName ? props.extraClassName : "")}
			value={props.value}
			checked={isChecked}
			onChange={handleChange}
		/>
		<label htmlFor={uniqueId} className={Utilities.classNames("ml-2 label", !!props.extraLabelClassName ? props.extraLabelClassName : "")}>
			{props.label}
		</label>
	</div>;
};